import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

export default class OutroService {

    getOutros(params, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/defaultoutro',
                method: 'get',
                params: params,
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getOutro(uuid, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/defaultoutro/' + uuid,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postOutro(outro, token) {
        return new Promise((done, reject) => {

            var instance = {
                baseURL: base + '/api/defaultoutro',
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                },
                data: outro
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putOutro(uuid, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/defaultoutro/' + uuid,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    deleteOutro(uuid, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/defaultoutro/' + uuid,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }


}